import { forwardRef } from 'react';

import { styled } from '@spazious/dollhouse-theme';

import { Flex, FlexElement, FlexProps } from '../Flex/index.js';
import { Typography } from '../Typography/index.js';

export const BadgeOuter = styled(Flex)`
  position: relative;
`;

export const BadgeInner = styled(Flex)`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  white-space: nowrap;
  padding: calc(var(--spacing-gap) / 2);
  background-color: var(--spz-sys-color-error);
  color: var(--spz-sys-color-on-error);
  border-radius: 24px;
  min-width: 24px;
  justify-content: center;
  align-items: center;
  z-index: 1;
`;

export type BadgeElement = FlexElement;
export interface BadgeProps extends FlexProps {
  children: React.ReactNode;
  visible?: boolean;
  count?: React.ReactNode;
}

export const Badge = styled(
  forwardRef<BadgeElement, BadgeProps>(({ children, visible = true, count, ...restProps }, ref) => {
    return (
      <BadgeOuter ref={ref} {...restProps}>
        {visible && (
          <BadgeInner>
            <Typography size="small" variant="label">
              {count}
            </Typography>
          </BadgeInner>
        )}
        {children}
      </BadgeOuter>
    );
  })
).withConfig({
  displayName: 'Badge',
})``;
